import useSplitedTableByColumn from '../../../hooks/useSplitedTableByColumn';
import { Table } from '../../Table';
import { StyledTables } from '../style';
import { TableComponentProps } from '../types';

const _tables = [
  {
    name: 'Estimated % of market value of securities traded',
    key: 'market',
    order: 148,
    columnLables: {
      regulated_market_rate: {
        name: 'Percentage of market value for securities traded on regulated exchanges'
      },
      otc_rate: {
        name: 'Percentage of market value for securities traded on OTC'
      }
    }
  },
  {
    name: 'Estimated % of trade volume of derivatives traded',
    key: 'market2',
    order: 150,
    columnLables: {
      regulated_derivative_market_rate: {
        name: 'Percentage of trade volumes for derivatives traded on regulated exchanges'
      },
      otc_derivative_rate: {
        name: 'Percentage of trade volumes for derivatives traded on OTC'
      }
    }
  }
];

const _tables2 = [
  {
    name: 'Estimated % of Trade volumes of derivative transactions cleared',
    key: 'market',
    order: 152,
    columnLables: {
      ccp_clearing_rate: {
        name: 'Percentage of trade volumes for derivatives cleared by a CCP'
      },
      bilateral_clearing_rate: {
        name: 'Percentage of trade volumes for derivatives cleared bilaterally'
      }
    }
  },
  {
    name: 'Estimated % of Market value of repo trades cleared',
    key: 'market2',
    order: 154,
    columnLables: {
      ccp_repo_clearing_rate: {
        name: 'Percentage of market value for repos trades cleared by a CCP'
      },
      bilateral_repo_clearing_rate: {
        name: 'Percentage of market value for repos trades cleared bilaterally'
      },
      tri_party_repo_clearing_rate: {
        name: 'Percentage of market value for repos trades cleared with triparty repos'
      }
    }
  }
];

export function Tranding({
  funds,
  onChangeFund,
  currentDataKey,
  schema,
  isStaticTemplate,
  isMultiFunds
}: TableComponentProps) {
  const {
    tables,
    columns: columns,
    onChange: onChange
  } = useSplitedTableByColumn({
    data: funds[currentDataKey]?.fund_data?.TRADING_CLEARING_DETAILS,
    onChangeFund,
    schema: schema.TRADING_CLEARING_DETAILS,
    isStaticTemplate,
    requiredFields:
      funds[currentDataKey]?.required_tables?.TRADING_CLEARING_DETAILS?.field_names || [],
    tableName: 'TRADING_CLEARING_DETAILS',
    tables: _tables,
    isMultiFunds,
    funds,
    isSingleData: true
  });

  const {
    tables: tables2,
    columns: columns2,
    onChange: onChange2
  } = useSplitedTableByColumn({
    data: funds[currentDataKey]?.fund_data?.TRADING_CLEARING_DETAILS,
    onChangeFund,
    schema: schema.TRADING_CLEARING_DETAILS,
    isStaticTemplate,
    requiredFields:
      funds[currentDataKey]?.required_tables?.TRADING_CLEARING_DETAILS?.field_names || [],
    tableName: 'TRADING_CLEARING_DETAILS',
    tables: _tables2,
    isMultiFunds,
    funds,
    isSingleData: true
  });

  return (
    <div
      id="reporttables-tranding-root"
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '10px'
      }}
    >
      <StyledTables id="reporttables-tranding-group-1">
        {tables.map((rows, index) => (
          <Table
            key={index + 'TRADING_CLEARING_DETAILS'}
            id={`reporttables-tranding-table-1-${index + 1}`}
            handleChanges={onChange}
            columns={columns}
            rows={rows}
            stickyLeftColumns={isMultiFunds && Object.keys(funds).length > 2 ? 2 : null}
          />
        ))}
      </StyledTables>
      <StyledTables id="reporttables-tranding-group-2">
        {tables2.map((rows, index) => (
          <Table
            key={index + 'TRADING_CLEARING_DETAILS-2'}
            id={`reporttables-tranding-table-2-${index + 1}`}
            handleChanges={onChange}
            columns={columns}
            rows={rows}
            stickyLeftColumns={isMultiFunds && Object.keys(funds).length > 2 ? 2 : null}
          />
        ))}
      </StyledTables>
    </div>
  );
}
